import { Card ,Row,Col, Divider,message, Typography,Form,Select,DatePicker,Button} from "antd";
import React, { Component } from "react";
import Chart from "react-apexcharts";
import storage from "../../utils/storage";
import { configs } from "../../config/config";
import {  defaultDropShadow,defaultStroke,defaultColors} from "../../model/dashboard/datasource";
import { GetNfcChartsData, GetNfcChartsDataDate } from "../../model/dashboard/requests";
import { formatDateString } from "../../utils/utils";
import { getGroup } from "../../model/group/requests";

const {Title} = Typography
const {Option} = Select;
const  {RangePicker} = DatePicker;
class DashBoardNfc extends Component {
    constructor(props){
        super(props)
        this.state = {
            options_chart1:{},
            series_chart1:[],
            options_chart2:{},
            series_chart2:[],
            customList:[],
            filterDate:[],
            filterCustom:"",

        };
    }

    componentWillUnmount(){
        if (!storage.check(configs.cache.tokenKey)) {
            this.props.history.push("/")
        }
    }

    handlerCustomChange = (item)=>{
        console.log(item)
        this.setState({
            filterCustom:item.label
        })
    }
    handlerDateChange = (date,dtString) =>{
        console.log(dtString)
        this.setState({
            filterDate:dtString
        })
    }

    handlerSearch = ()=>{
        let custom = this.state.filterCustom
        let start = this.state.filterDate.length ==2 ? this.state.filterDate[0] : "";
        let end = this.state.filterDate.length ==2 ? this.state.filterDate[1] : "";
        let  options_chart2 ={
            title: {
              text: 'NFC Operations (24 hours)',
              align: 'left'
            },
            colors: defaultColors,
            xaxis: {},
        }

       let options_chart1 = {
            chart: {
              dropShadow: defaultDropShadow,
            },
            stroke: defaultStroke,
            title: {
              text: 'Total',
               align: 'left'
            },
            colors: defaultColors,
            xaxis: {
                tickPlacement: 3,
            },
            
          }


        let series_chart2 = []

        let _categories2 = []


        let series_chart1 = []

        let _categories1 = []
        GetNfcChartsData({start:start,end:end,custom_id:custom}).then(res=>{
            if(res.data.code === 200){
                let ret = res.data.data
                let _category = []
                let _data_reads = []
                let _data_writes = []
                let _data_errors = []
                for(let i=0;i<ret.length;i++){
                    _category.push(ret[i].custom_id)
                    _data_reads.push(ret[i].read_nums)
                    _data_writes.push(ret[i].write_nums)
                    _data_errors.push(ret[i].error_nums)
                }
                let _series_data_read = {}
                let _series_data_write = {}
                let _series_data_error = {}
                _series_data_read.data = _data_reads        
                _series_data_read.name = "Read" 
                series_chart2.push(_series_data_read)

                _series_data_write.data = _data_writes        
                _series_data_write.name = "Write" 
                series_chart2.push(_series_data_write)

                _series_data_error.data = _data_errors        
                _series_data_error.name = "Error" 
                series_chart2.push(_series_data_error)

                if(_categories2.length <= 0 ){
                    _categories2.push(..._category)
                }
            }
   

        }).catch(err=>{
            message.error(err)
        })

        GetNfcChartsDataDate({start:start,end:end,custom_id:custom}).then(res=>{
            if(res.data.code === 200){
                let ret = res.data.data
                let _category = []
                let _data_reads = []
                let _data_writes = []
                let _data_error_read = []
                let _data_error_write = []
                for(let i=0;i<ret.length;i++){
                    let dates = formatDateString(ret[i].dates)
                    _category.push(dates)
                    _data_reads.push(ret[i].read_nums)
                    _data_writes.push(ret[i].write_nums)
                    _data_error_read.push(ret[i].error_reads)
                    _data_error_write.push(ret[i].error_writes)
                }

                let _series_data_read = {}
                let _series_data_write = {}
                let _series_data_error_read = {}
                let _series_data_error_write = {}

                _series_data_read.data = _data_reads        
                _series_data_read.name = "Read" 
                series_chart1.push(_series_data_read)

                _series_data_write.data = _data_writes        
                _series_data_write.name = "Write" 
                series_chart1.push(_series_data_write)

                _series_data_error_read.data = _data_error_read        
                _series_data_error_read.name = "Error Read" 
                series_chart1.push(_series_data_error_read)

                _series_data_error_write.data = _data_error_write        
                _series_data_error_write.name = "Error Write" 
                series_chart1.push(_series_data_error_write)


                if(_categories1.length <= 0 ){
                    _categories1.push(..._category)
                }

            }
        }).catch(err=>{
            message.error(err)
        })


        setTimeout(() => {
            options_chart2.xaxis.categories = [..._categories2]
            options_chart1.xaxis.categories = [..._categories1]
            this.setState({
                options_chart2:options_chart2,
                series_chart2:series_chart2,
                options_chart1:options_chart1,
                series_chart1:series_chart1,

            })
 
          }, 500);
    }

     


    componentDidMount(){
        // 加载NFC 相关统计书记
       let  options_chart2 ={
            title: {
              text: 'NFC Operations (24 hours)',
              align: 'left'
            },
            colors: defaultColors,
            xaxis: {},
        }

       let options_chart1 = {
            chart: {
              dropShadow: defaultDropShadow,
            },
            stroke: defaultStroke,
            title: {
              text: 'Total',
               align: 'left'
            },
            colors: defaultColors,
            xaxis: {
                tickPlacement: 3,
            },
            
          }

        let series_chart2 = []
        let _categories2 = []
        let series_chart1 = []
        let _categories1 = []

        GetNfcChartsData({start:"",end:"",custom_id:""}).then(res=>{
            if(res.data.code === 200){
                let ret = res.data.data
                let _category = []
                let _data_reads = []
                let _data_writes = []
                let _data_errors = []
                for(let i=0;i<ret.length;i++){
                    _category.push(ret[i].custom_id)
                    _data_reads.push(ret[i].read_nums)
                    _data_writes.push(ret[i].write_nums)
                    _data_errors.push(ret[i].error_nums)
                }
                let _series_data_read = {}
                let _series_data_write = {}
                let _series_data_error = {}
                _series_data_read.data = _data_reads        
                _series_data_read.name = "Read" 
                series_chart2.push(_series_data_read)

                _series_data_write.data = _data_writes        
                _series_data_write.name = "Write" 
                series_chart2.push(_series_data_write)

                _series_data_error.data = _data_errors        
                _series_data_error.name = "Error" 
                series_chart2.push(_series_data_error)

                if(_categories2.length <= 0 ){
                    _categories2.push(..._category)
                }


                
            }

        }).catch(err=>{
            message.error(err)
        })


        // 
        GetNfcChartsDataDate({start:"",end:"",custom_id:""}).then(res=>{
            if(res.data.code === 200){
                let ret = res.data.data
                let _category = []
                let _data_reads = []
                let _data_writes = []
                let _data_error_read = []
                let _data_error_write = []
                for(let i=0;i<ret.length;i++){
                    let dates = formatDateString(ret[i].dates)
                    _category.push(dates)
                    _data_reads.push(ret[i].read_nums)
                    _data_writes.push(ret[i].write_nums)
                    _data_error_read.push(ret[i].error_reads)
                    _data_error_write.push(ret[i].error_writes)
                }

                let _series_data_read = {}
                let _series_data_write = {}
                let _series_data_error_read = {}
                let _series_data_error_write = {}

                _series_data_read.data = _data_reads        
                _series_data_read.name = "Read" 
                series_chart1.push(_series_data_read)

                _series_data_write.data = _data_writes        
                _series_data_write.name = "Write" 
                series_chart1.push(_series_data_write)

                _series_data_error_read.data = _data_error_read        
                _series_data_error_read.name = "Error Read" 
                series_chart1.push(_series_data_error_read)

                _series_data_error_write.data = _data_error_write        
                _series_data_error_write.name = "Error Write" 
                series_chart1.push(_series_data_error_write)


                if(_categories1.length <= 0 ){
                    _categories1.push(..._category)
                }

            }
        }).catch(err=>{
            message.error(err)
        })

        let data = storage.get(configs.cache.tokenKey)
        let group_id = data.group_id
        let customList = [];
        getGroup({id:group_id}).then(res=>{
            if(res.data.code == 200){
                customList = res.data.data.customs
            }else{
                message.error(res.data.msg)
            }

        }).catch(err=>{
            message.error(err)
        })

 

        //
        setTimeout(() => {
            options_chart2.xaxis.categories = [..._categories2]
            options_chart1.xaxis.categories = [..._categories1]
            this.setState({
                options_chart2:options_chart2,
                series_chart2:series_chart2,
                options_chart1:options_chart1,
                series_chart1:series_chart1,
                customList:customList

            })
 
          }, 500);
       
    }
    render(){
        const {customList}  = this.state;
        return(
            <>
            <Title>NFC Activity</Title>
            <Row gutter={[24, 0]}>
                <Col xs={24} sm={24} md={12} lg={12} xl={24} className="mb-24">
                <Card bordered={false} className="criclebox " >
                <Chart
                    options={this.state.options_chart1}
                    series={this.state.series_chart1}
                    type="line"
                    width="100%"
                    height={"500px"}
       
                />
                </Card>
              </Col>
            </Row>
            <Divider />
            <Row gutter={[24, 0]}>
                <Col xs={24} sm={24} md={12} lg={12} xl={24} className="mb-24">
                <Card bordered={false} className="criclebox " >
                <Chart
                    options={this.state.options_chart2}
                    series={this.state.series_chart2}
                    width="100%"
                    type="bar"
                    height={"400px"}
                />
                </Card>
              </Col>
            </Row>
            <Divider />
            <Form  name="horizontal_login" layout="inline"  ref={this.formRef} >
                <Form.Item
                    name="date"
                >
                   <RangePicker 
                    onChange={this.handlerDateChange}
                    format="YYYY-MM-DD" />
                </Form.Item>

                    <Form.Item name={'name'}>
                        <Select 
                         placeholder={"Please Chosen a Custom  Id"}
                         onChange={this.handlerCustomChange}
                         labelInValue
                          >
                        <Option key={0} value={0} >
                            All
                        </Option>
                        {customList.length > 0  && customList.map((items) => {
                                return (<Option key={items.id} value={items.id}>{items.name}</Option>)
                        })}

                        </Select>
                    </Form.Item> 
                    <Form.Item shouldUpdate>
       
                    <Button
                        type="primary"
                        style={{background: "#851dd6" }}
                        onClick={this.handlerSearch}
                    >

                       Filter
                    </Button>
     
                    </Form.Item>
            </Form> 

            </>
        )
    }
}

export default DashBoardNfc;
